import { render, staticRenderFns } from "./TheHomeScreen.vue?vue&type=template&id=98010aa0&"
import script from "./TheHomeScreen.vue?vue&type=script&lang=js&"
export * from "./TheHomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheHomeScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports